import { supabase } from './supabaseClient'

// Creates a class meeting link through our own /api/meetings function:
// Google Meet (anyone with the link joins directly, recorded where the
// Workspace plan allows), or Zoom until Google is configured. Returns null
// on failure so callers can fall back to a Jitsi link.
export async function createMeetingLink(topic, date, time, durationMinutes = 60) {
  try {
    const { data: { session } } = await supabase.auth.getSession()
    const res = await fetch('/api/meetings', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ topic, date, time: time || undefined, durationMinutes, accessToken: session?.access_token }),
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok || !data?.joinUrl) throw new Error(data?.error || `Meeting creation failed (${res.status})`)
    return { url: data.joinUrl, provider: data.provider || 'google-meet' }
  } catch(e) {
    console.error('Meeting link creation failed:', e.message)
    return null
  }
}

export function createJitsiLink(topic, date, time) {
  const clean   = (topic || 'class').toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 30)
  const dateStr = (date  || new Date().toISOString().slice(0, 10)).replace(/-/g, '')
  const timeStr = (time  || '0000').replace(':', '')
  return `https://meet.jit.si/UniEDD${clean}${dateStr}${timeStr}`
}

// ── Teachers/students only see the join link starting 24h before class —
// keeps it from being pasted around or joined early. Admins always see it
// (they need it for management), so callers should skip this check for
// admin views. Same IST assumption Calendar.js/ScheduleClasses.js use.
export function isMeetLinkVisible(classDate, startTime) {
  if (!classDate) return false
  const start = new Date(`${classDate}T${startTime || '00:00'}:00+05:30`)
  if (isNaN(start)) return false
  return start.getTime() - Date.now() <= 24 * 60 * 60 * 1000
}
